const Project = ({ project }) => {
  return (
    <div className="mobile_slider_item">
      <div
        className="capsule"
        style={{ backgroundImage: `url(${project.images[0]})` }}
      ></div>
      <div className="info">
        <h3>{project.title}</h3>
        <a href={project.link}>Visit Site</a>
      </div>
    </div>
  );
};

export default Project;
